// Older workers stored this specific generation failure as REJECTED. Recognize
// only that exact diagnostic so existing cards gain Retry without a DB rewrite.
const LEGACY_FILTERED_CONTENT_ERROR =
  'Не нашли подходящих словарных переводов для этого слова. ' +
  'Попробуй другое слово или добавь карточку вручную.';

const KNOWN_WORD_GENERATION_ERROR =
  'Слово найдено, но не удалось подготовить карточку. Попробуй сгенерировать её ещё раз.';

export function generationFailureMessage(
  status: string | null | undefined,
  errorInfo: string | null | undefined,
): string | null {
  if (status === 'failed') {
    return errorInfo || 'Не удалось завершить генерацию карточки.';
  }
  if (status === 'rejected' && errorInfo === LEGACY_FILTERED_CONTENT_ERROR) {
    return KNOWN_WORD_GENERATION_ERROR;
  }
  return null;
}
